import { isArray, isUndefined, isEmpty, isNull, isNil, forEach, every, compact, keys } from 'lodash'

const formatSortStrings = ({ sort }) => {
  const sortResults = []

  if (isEmpty(sort)) {
    return sortResults
  }

  forEach(sort, (direction, key) => {
    sortResults.push(`sort=${key},${direction}`)
  })

  return sortResults
}

const formatFilterStrings = ({ filters }) => {
  const filterResults = []

  if (isEmpty(filters)) {
    return filterResults
  }

  forEach(filters, (value, key) => {
    if (value !== '' && !isUndefined(value)) {
      const keyEncoded = encodeURIComponent(key)

      // NOTE: 123 --> 123 --> "123"
      //       [] --> [] --> ""
      //       [null] --> "," --> "%2C" (format is required by back-end)
      //       [null, 1] --> ",1" --> "%2C1"
      //       [1, 2] --> "1,2" --> "1%2C2"
      // for more examples look in `queryString.test.js`
      if (isArray(value)) {
        if (!isEmpty(value) && every(value, isNull)) {
          value = ','.concat(value.join(','))
        } else {
          value = value.join(',')
        }
      }
      const filterValue = encodeURIComponent(value)

      filterResults.push(`${keyEncoded}=${filterValue}`)
    }
  })

  return filterResults
}

export const formatQueryString = ({ page, size, sort, filters }) =>
  compact([
    !isNil(page) ? `page=${page}` : null,
    !isNil(size) ? `size=${size}` : null,
    ...formatSortStrings({ sort }),
    ...formatFilterStrings({ filters }),
  ]).join('&')

export const formatRequestString = ({ entityUrl, params }) => {
  const urlKeys = keys(params)

  let urlFormatted = entityUrl

  urlKeys.forEach(key => {
    urlFormatted = urlFormatted.replace(`$${key}$`, params[key])
  })

  return urlFormatted
}
